module.exports = __webpack_public_path__ + "static/merch-bb3ef80c828a2bd5923e14f00d3a5928.mp4";